module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-arc-cbccd8f652cac435a89e9579a4083e1b.svg";